import React from 'react'
import { Button, Form, Modal } from 'semantic-ui-react'
import { find } from 'lodash/collection'

import { token } from 'utils/csrf'

const FIELD_NAME = 'items_command[collection_id]'
const SELECTS = [
  { name: 'offer', label: 'Do nabídky:' },
  // { name: 'website', label: 'Na web:' },
  { name: 'auction', label: 'Do aukce:' },
]

export class ActionModal extends React.PureComponent {
  state = {
    submitting: false,
    collectionId: '',
    collectionType: null,
  }

  onSubmit () {
    this.setState({ ...this.state, submitting: true })
  }

  onChange (e, collectionType) {
    this.setState({
      ...this.state,
      collectionType,
      collectionId: e.target.value,
    })
  }

  getFieldName (name) {
    if (name === this.state.collectionType) return FIELD_NAME
    return name
  }

  selects () {
    if (!this.props.singleCollection) return SELECTS
    return [find(SELECTS, { name: this.props.singleCollection })]
  }

  render () {
    const { modalOpen, close, items, form_action, collections } = this.props

    return (
      <Modal
        closeIcon
        size='tiny'
        open={modalOpen}
        dimmer='inverted'
        closeOnDimmerClick
        onClose={close}
      >
        <Modal.Header>
          {items.length > 1 ? `Vybrané (${items.length}) přidat` : 'Přidat předmět'}
        </Modal.Header>

        <Modal.Content>
          <form
            action={form_action}
            className={`ui form ${this.state.submitting ? 'loading' : ''}`}
            method='POST'
            onSubmit={() => this.onSubmit()}
          >

            {this.selects().map((select) => {
              if (collections[select.name].length === 0) return null
              return (
                <Form.Field
                  key={select.name}
                  label={select.label}
                  control='select'
                  name={this.getFieldName(select.name)}
                  onChange={(e) => this.onChange(e, select.name)}
                  value={this.state.collectionType === select.name ? this.state.collectionId : ''}
                >
                  <option value=''></option>
                  {collections[select.name].map((option) => (
                    <option key={option.id} value={option.id}>{option.name}</option>
                  ))}
                </Form.Field>
              )
            })}

            <input type='hidden' name='items_command[type]' value='ItemsCommand::Insert' />
            {items.map((item) => (
              <input type='hidden' name='items_command[item_ids][]' value={item} key={item} />
            ))}
            <input type='hidden' name="authenticity_token" value={token} />

            <Button type='button' onClick={close}>Zrušit</Button>
            <Button primary type='submit'>Uložit</Button>
          </form>
        </Modal.Content>
      </Modal>
    )
  }
}

export default ActionModal



// WEBPACK FOOTER //
// ./app/javascript/components/ActionBar/ActionModal.js